import React from 'react';
import { FaBars } from 'react-icons/fa';
import {
  Nav,
  NavLink,
  NavLinkExternal,
  NavbarContainer,
  NavLogo,
  NavItems,
  GitHubButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
  MobileLinkExternal,
} from './NavbarStyledComponent';
import { Bio } from '../../data/constants';
import { useTheme } from 'styled-components';
import furLogo from '../../images/furLogo.png';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Experience', to: '/experience' },
  { label: 'Projects', to: '/projects' },
  { label: 'Education', to: '/education' },
  { label: 'Contact', to: '/contact' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme()
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
          <img src={furLogo} alt="Mohammed Furquan Saleem Logo" />
        </NavLogo>

        <MobileIcon onClick={() => setIsOpen((prev) => !prev)} aria-label="Toggle navigation">
          <FaBars />
        </MobileIcon>
        <NavItems>
          {navLinks.map(({ label, to, external }) => (
            external ? (
              <NavLinkExternal
                key={label}
                href={to}
                target="_blank"
                rel="noreferrer"
              >
                {label}
              </NavLinkExternal>
            ) : (
              <NavLink
                key={label}
                to={to}
                end={to === '/'}
              >
                {label}
              </NavLink>
            )
          ))}
        </NavItems>
        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank" rel="noreferrer" aria-label="GitHub Profile">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 .5C5.65.5.5 5.65.5 12a11.5 11.5 0 008.06 10.94c.59.11.8-.26.8-.58v-2.08c-3.28.71-3.97-1.59-3.97-1.59a3.15 3.15 0 00-1.33-1.75c-1.09-.75.08-.74.08-.74a2.48 2.48 0 011.81 1.22 2.52 2.52 0 003.44 1 2.51 2.51 0 01.75-1.58c-2.63-.3-5.39-1.32-5.39-5.89a4.6 4.6 0 011.22-3.19 4.29 4.29 0 01.12-3.15s1-.32 3.3 1.21a11.32 11.32 0 016 0c2.3-1.53 3.3-1.21 3.3-1.21a4.29 4.29 0 01.12 3.15 4.6 4.6 0 011.22 3.19c0 4.59-2.76 5.58-5.4 5.88a2.82 2.82 0 01.79 2.2v3.26c0 .32.21.7.81.58A11.5 11.5 0 0023.5 12C23.5 5.65 18.35.5 12 .5z" />
            </svg>
          </GitHubButton>
        </ButtonContainer>
        <MobileMenu isOpen={isOpen}>
          {navLinks.map(({ label, to, external }) => (
            external ? (
              <MobileLinkExternal
                key={label}
                href={to}
                target="_blank"
                rel="noreferrer"
                onClick={() => setIsOpen(false)}
              >
                {label}
              </MobileLinkExternal>
            ) : (
              <MobileLink
                key={label}
                to={to}
                end={to === '/'}
                onClick={() => setIsOpen(false)}
              >
                {label}
              </MobileLink>
            )
          ))}
          <GitHubButton
            style={{
              padding: '12px',
              background: theme.primary,
              color: '#fff',
              width: 'fit-content',
              justifyContent: 'center',
            }}
            href={Bio.github}
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub Profile"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 .5C5.65.5.5 5.65.5 12a11.5 11.5 0 008.06 10.94c.59.11.8-.26.8-.58v-2.08c-3.28.71-3.97-1.59-3.97-1.59a3.15 3.15 0 00-1.33-1.75c-1.09-.75.08-.74.08-.74a2.48 2.48 0 011.81 1.22 2.52 2.52 0 003.44 1 2.51 2.51 0 01.75-1.58c-2.63-.3-5.39-1.32-5.39-5.89a4.6 4.6 0 011.22-3.19 4.29 4.29 0 01.12-3.15s1-.32 3.3 1.21a11.32 11.32 0 016 0c2.3-1.53 3.3-1.21 3.3-1.21a4.29 4.29 0 01.12 3.15 4.6 4.6 0 011.22 3.19c0 4.59-2.76 5.58-5.4 5.88a2.82 2.82 0 01.79 2.2v3.26c0 .32.21.7.81.58A11.5 11.5 0 0023.5 12C23.5 5.65 18.35.5 12 .5z" />
            </svg>
          </GitHubButton>
        </MobileMenu>
      </NavbarContainer>
    </Nav>
  )
}

export default Navbar